import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../../../util/asyncComponent';


const TransportSupport = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/vendor`}/>
            <Route path={`${match.url}/vendor`} component={asyncComponent(() => import('./routes/Vendor'))}/>
            <Route path={`${match.url}/vendor-status`} component={asyncComponent(() => import('./routes/VendorStatus'))}/>
            <Route path={`${match.url}/area`} component={asyncComponent(() => import('./routes/Area'))}/>
            <Route path={`${match.url}/pool`} component={asyncComponent(() => import('./routes/Pool'))}/>
            <Route path={`${match.url}/group`} component={asyncComponent(() => import('./routes/GroupCustomer'))}/>
            <Route path={`${match.url}/vehicle-type`} component={asyncComponent(() => import('./routes/VehicleType'))}/>
            <Route path={`${match.url}/tail-truck`} component={asyncComponent(() => import('./routes/TailTruck'))}/>
            <Route path={`${match.url}/Vehicle`} component={asyncComponent(() => import('./routes/Vehicle'))}/>
            <Route path={`${match.url}/driver`} component={asyncComponent(() => import('./routes/Driver'))}/>
            <Route path={`${match.url}/delivery`} component={asyncComponent(() => import('./routes/DeliveryCost'))}/>
            <Route path={`${match.url}/service`} component={asyncComponent(() => import('./routes/ServiceType'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default TransportSupport;


// WEBPACK FOOTER //
// ./app/routes/MasterData/routes/TransportSupport/index.js